<ul class="pkg-grid" [class.pkg-grid--services]="variant === 'services'" [class.pkg-grid--home]="variant === 'home'">
  <li class="pkg-card" *ngFor="let p of packages; let index = index; trackBy: trackByIndex" appReveal="rise" revealBatch>
    <article
      class="pkg-face"
      [attr.data-tone]="tone(p)"
      appTilt
      [ngStyle]="{ 'background-color': p.bgColor, color: p.fontColor }"
      [style.--glare-rgb]="p.fontColor === 'white' ? '255,255,255' : '105,80,161'"
      [style.--glare-a]="p.fontColor === 'white' ? 0.18 : 0.12"
    >
      <span class="tilt-glare" aria-hidden="true"></span>
      <span *ngIf="variant === 'home'" class="pkg-number" aria-hidden="true">0{{ index + 1 }} <span>↗</span></span>
      <h3 class="pkg-type" [style.color]="p.fontColor">{{ p.type }}</h3>
      <p class="pkg-goal" *ngIf="p.goal" [style.color]="p.fontColor">{{ p.goal }}</p>
      <ul class="pkg-list">
        <li *ngFor="let line of p.lines; trackBy: trackByIndex" [style.color]="p.fontColor">{{ line }}</li>
      </ul>
      <p class="pkg-desc" *ngIf="p.description" [style.color]="p.fontColor">{{ p.description }}</p>
      <!-- The flexible body keeps the prices aligned across a row. -->
      <div class="pkg-foot">
        <p class="pkg-price" [style.color]="p.fontColor" [appOdometer]="p.price" [odometerDelay]="0.35"></p>
        <img class="pkg-icon" [src]="p.icon" alt="" width="157" height="157" />
      </div>
      <a *ngIf="variant === 'home'" class="pkg-details" [routerLink]="detailsLink()" [attr.aria-label]="('home.design.courseAction' | translate) + ': ' + p.type">
        <span>{{ 'home.design.courseAction' | translate }}</span><span class="brand-icon brand-icon--arrow" aria-hidden="true"></span>
      </a>
    </article>
  </li>
</ul>
